export default "__VITE_ASSET__BCeVFnot__"